import { createStyles } from 'antd-style';

import { ThemeFont, ThemeSpaces } from '../../../theme';

export const useShipmentDetailsStyles = createStyles(({ token }) => ({
  shipmentDetails: {
    paddingRight: ThemeSpaces.SPACE_XL,
    fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
    fontWeight: 500,

    [`@media (max-width: ${token.screenMDMax}px)`]: {
      padding: 0,
      fontWeight: 400,
    },

    '.ShipmentDetailsTitle': {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      fontFamily: ThemeFont.FONT_CONDENSED,
      fontWeight: 700,

      [`@media (min-width: ${token.screenMDMin}px)`]: {
        fontSize: token.fontSize,
      },
    },
  },
}));
